import { Box, Drawer, Typography, Dialog, DialogContent } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import CustomSelect from '../../../../../common/components/customized/customselect/CustomSelect';
import './Dispatch.scss';
import CustomCheckBox from '../../../../../common/components/customized/customcheckbox/CustomCheckBox';
import CustomMultiSelect from '../../../../../common/components/customized/custommultiselect/CustomMultiSelect';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import {
  addDispatch,
  getDispatchList,
  getDispatchTrailer,
  updateDispatch
} from '../../../redux/reducer/truckManagementSlices/dispatchSlice';
import InspectionView from './InspectionView';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import { getMyProfileAction } from '../../../../../common/redux/reducer/commonSlices/myProfileSlice';

const customerSchema = yup.object().shape({
  truckLoadType: yup
    .string()
    .required('Truck Load is required')
    .min(1, 'Truck Load is required'),
  loadType: yup
    .string()
    .required('Load Type is required')
    .min(1, 'Load Type is required'),
  trailerType: yup
    .string()
    .required('Trailer Type is required')
    .min(1, 'Trailer Type  is required'),
  load: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string().required(),
        label: yup.string().required()
      })
    )
    .required('freight is required')
    .min(1, 'freight is required'),
  trailer: yup.string().required('Select Trailer Name'),
  truck: yup.string().required('Select Truck Name')
});

const loadSchema: any = yup.object().shape({
  truckLoadType: yup
    .string()
    .required('Truck Load is required')
    .min(1, 'Truck Load is required'),
  loadType: yup
    .string()
    .required('Load Type is required')
    .min(1, 'Load Type is required'),
  trailerType: yup
    .string()
    .required('Trailer Type is required')
    .min(1, 'Trailer Type  is required'),
  load: yup.string().required('Load is required'),
  trailer: yup.string().required('Select Trailer Name'),
  truck: yup.string().required('Select Truck Name')
});

interface AddDispatch {
  open: boolean;
  setOpen: any;
  roleType: string;
  filteredRow: any;
  setFilteredRow: any;
  isLoading: any;
  label: any;
  setTablePayload?: any;
  setPageNo?: any;
  setPageSize?: any;
}

interface Options {
  id: string;
  label: string;
}

interface TextField {
  id: string;
  label: string;
  field: 'load' | 'trailer' | 'truck' | 'loadType' | 'truckLoadType' | 'trailerType';
  placeholder: string;
  options: Options[];
}

const AddDispatch = ({
  open,
  setOpen,
  roleType,
  filteredRow,
  setFilteredRow,
  isLoading,
  label,
  setTablePayload,
  setPageNo,
  setPageSize
}: AddDispatch) => {
  const [inspection, setInspection] = useState(false);
  const [inspectionName, setInspectionName] = useState();
  const [inspectionId, setInspectionId] = useState<any>();
  const [disabled, setDisabled] = useState<any>(false);
  const [loadType, setLoadType] = useState<any>('');
  const [truckLoadType, setTruckLoadType] = useState<any>('');
  const [checked, setChecked] = useState<boolean>(false);

  const { dropdownList } = useAppSelector((state: any) => state.dispatchDropdown);
  const { dropdownListTrailer } = useAppSelector((state: any) => state.dispatchTrailer);
  const { isLoading: addLoading } = useAppSelector((state: any) => state.addDispatch);
  const { isLoading: updateLoading } = useAppSelector(
    (state: any) => state.dispatchUpdate
  );
  const { userName } = useAppSelector(state => state.myProfile.data || { userName: '' });
  const dispatch = useAppDispatch();
  const abortController = useRef<AbortController | null>(null);

  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    getValues,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(truckLoadType === 'LTL' ? customerSchema : loadSchema)
  });

  const loadList = [
    ...(dropdownList?.loadNumber?.length > 0
      ? dropdownList?.loadNumber?.map((item: any) => ({
          id: item,
          label: item?.toUpperCase()
        }))
      : []),
    ...(filteredRow?.loadId
      ? filteredRow?.loadId?.map((item: any) => ({
          id: item,
          label: item?.toUpperCase()
        }))
      : [])
  ];
  const trailer = dropdownListTrailer?.unitNumber
    ? dropdownListTrailer?.unitNumber?.map((item: any) => ({
        id: item,
        label: item.toUpperCase()
      }))
    : [];

  const truckList = dropdownListTrailer?.truckNumber
    ? dropdownListTrailer?.truckNumber?.map((item: any) => ({
        id: item.toUpperCase(),
        label: item.toUpperCase()
      }))
    : [];

  const trailerList = dropdownList?.trailerType
    ? dropdownList?.trailerType?.map((item: any) => ({
        id: item,
        label: item
      }))
    : [];

  const loadItems = [
    { id: 'General Cargo', label: 'General Cargo' },
    { id: 'Refrigerator', label: 'Refrigerator' },
    { id: 'Tanker', label: 'Tanker' }
  ];

  const loadListItem = loadItems.map((value: any, index: number) => ({
    id: value.id,
    label: value.label
  }));

  const textField: TextField[] = [
    {
      id: '1',
      label: 'Load Type',
      field: 'loadType',
      placeholder: 'Load Type',
      options: loadListItem ?? []
    },
    {
      id: '2',
      label: 'Truck Load',
      field: 'truckLoadType',
      placeholder: 'Truck Load',
      options: [
        { id: 'FTL', label: 'FTL' },
        { id: 'LTL', label: 'LTL' }
      ]
    },

    {
      id: '3',
      label: 'Load',
      field: 'load',
      placeholder: 'Load',
      options: loadList ?? []
    },
    {
      id: '4',
      label: 'Trailer Type',
      field: 'trailerType',
      placeholder: 'Trailer Type',
      options: trailerList ?? []
    },

    {
      id: '5',
      label: 'Trailer',
      field: 'trailer',
      placeholder: 'Trailer',
      options: trailer ?? []
    },

    {
      id: '6',
      label: 'Truck',
      field: 'truck',
      placeholder: 'Truck',
      options: truckList ?? []
    }
  ];

  const onSubmit = async (data: any) => {
    if (filteredRow) {
      let updatePayload: any = {
        loadType: data?.loadType,
        truckLoadType: data?.truckLoadType,
        loadList:
          truckLoadType === 'LTL'
            ? data?.load?.map((value: any, index: number) => value.id)
            : [data?.load],
        trailerType: data?.trailerType,
        trailerUnitNumber: data.trailer,
        truckNumber: data.truck?.toLowerCase(),
        isInspectionNeeded: checked ? 1 : 0,
        inspectionId: inspectionId ? inspectionId.concat(userName) : inspectionId,
        inspectorName: inspectionName
      };

      let payload: { updatePayload: any; id: any } = {
        updatePayload: updatePayload,
        id: filteredRow.id
      };
      const action1 = await dispatch(updateDispatch(payload));
      if (action1.type === updateDispatch.fulfilled.type) {
        setOpen(false);
        setInspection(false);
        setTablePayload({
          pageNo: 1,
          pageSize: 5
        });
        setPageNo(1);
        setPageSize(5);
      }
    } else {
      const action2 = await dispatch(
        addDispatch({
          loadType: data?.loadType,
          truckLoadType: data?.truckLoadType,
          loadList:
            truckLoadType === 'LTL'
              ? data?.load?.map((value: any, index: number) => value.id)
              : [data?.load],
          trailerType: data?.trailerType,
          trailerUnitNumber: data.trailer,
          truckNumber: data.truck?.toLowerCase(),
          isInspectionNeeded: checked ? 1 : 0,
          inspectionId: inspectionId,
          inspectorName: inspectionName
        })
      );
      if (action2.type === addDispatch.fulfilled.type) {
        setOpen(false);
        setInspection(false);
        setTablePayload({
          pageNo: 1,
          pageSize: 5
        });
        setPageNo(1);
        setPageSize(5);
      }
    }
  };

  const handleClose = () => {
    setValue('load', []);
    setValue('trailer', '');
    setValue('truck', '');
    setValue('loadType', '');
    setValue('truckLoadType', '');
    setFilteredRow(null);
    reset();
    setOpen(false);
  };

  useEffect(() => {
    if (filteredRow) {
      setValue('loadType', filteredRow?.loadType);
      setValue('truckLoadType', filteredRow?.truckLoadType);
      setTruckLoadType(filteredRow?.truckLoadType);
      dispatch(
        getDispatchList({
          loadType: filteredRow?.loadType,
          truckLoadType: filteredRow?.truckLoadType
        })
      );
      if (filteredRow?.inspectionReport) {
        setChecked(true);
      } else {
        setChecked(false);
      }
      dispatch(getDispatchTrailer(filteredRow?.trailerType));
      if (filteredRow?.truckLoadType === 'LTL') {
        setValue(
          'load',
          filteredRow?.loadId?.map((item: any) => ({
            id: item,
            label: item?.toUpperCase()
          })) || []
        );
      } else if (filteredRow?.truckLoadType === 'FTL') {
        setValue('load', filteredRow?.loadId[0]);
      }

      setValue('trailer', filteredRow?.trailerId);
      setValue('truck', filteredRow?.vehicleId);
      setValue('trailerType', filteredRow?.trailerType);
    }
  }, [filteredRow]);

  useEffect(() => {
    return () => {
      handleClose();
    };
  }, []);

  // useEffect(() => {
  //   if (abortController.current) abortController.current.abort();
  //   abortController.current = new AbortController();
  //   const { signal } = abortController.current;
  //   dispatch(getMyProfileAction(signal));
  //   reset();
  //   return () => {
  //     if (abortController.current) abortController.current.abort();
  //   };
  // }, []);

  return (
    <Box p={2}>
      <Drawer
        anchor='right'
        open={open}
        onClose={() => {
          setOpen(false);
          reset();
          handleClose();
        }}
        sx={{ zIndex: 1 }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px !important'
          }}
          className='animate__animated animate__slideInUp animate__fast'
        >
          <Typography sx={{ fontWeight: 700 }}>{label}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
              {textField?.map(item =>
                item.field === 'load' && truckLoadType === 'LTL' ? (
                  <CustomMultiSelect
                    key={item.id}
                    id='load'
                    control={control}
                    label={item.label}
                    name={item.field}
                    options={item?.options}
                    initialValue={filteredRow?.loadId}
                    placeholder={item.placeholder}
                    setValue={setValue}
                    width={'200px'}
                    loadtype={'load'}
                  />
                ) : (
                  <>
                    <CustomSelect
                      key={item.id}
                      id='select-vehicle'
                      control={control}
                      label={item.label}
                      name={item.field}
                      options={item.options}
                      placeholder={item.placeholder}
                      isDisabled={item?.field === 'truckLoadType' && disabled}
                      onChanges={(e: any, newValue: any) => {
                        if (
                          (item?.id === '1' && newValue?.id === 'Refrigerator') ||
                          newValue?.id === 'Tanker'
                        ) {
                          setLoadType(newValue?.id);
                          setDisabled(true);
                          setValue('truckLoadType', 'FTL');
                          dispatch(
                            getDispatchList({
                              loadType: newValue?.id,
                              truckLoadType: 'FTL'
                            })
                          );
                        } else if (item?.id === '1' && newValue?.id === 'General Cargo') {
                          setLoadType(newValue?.id);
                        }
                        if (item?.id === '2') {
                          setTruckLoadType(newValue?.id);
                          setValue('truckLoadType', newValue?.id);
                        }

                        if (newValue?.id === 'General Cargo') {
                          setValue('truckLoadType', '');
                          setDisabled(false);
                        }
                        if (newValue === null) {
                          setValue('truckLoadType', '');
                          setDisabled(false);
                        }
                        if (item?.id === '2' && newValue?.id) {
                          dispatch(
                            getDispatchList({
                              loadType: loadType,
                              truckLoadType: newValue?.id
                            })
                          );
                        }
                        if (item?.id === '4' && newValue?.id) {
                          dispatch(getDispatchTrailer(newValue?.id));
                        }
                      }}
                    />
                  </>
                )
              )}
              <CustomCheckBox
                name='inspectionRequired'
                value='yes'
                label='Inspection is required'
                size='medium'
                disabled={filteredRow?.inspectionReport ? true : false}
                control={control}
                checked={checked}
                onChange={e => {
                  setChecked(e.target.checked);
                  setInspection(true);
                }}
              />

              <Box sx={{ marginTop: '5%', display: 'flex', gap: '15px' }}>
                <CustomButton
                  className='saveChanges'
                  type='submit'
                  category={label}
                  loading={filteredRow ? updateLoading : addLoading}
                />
                <CustomButton
                  className='cancel'
                  category='Cancel'
                  onClick={() => {
                    handleClose();
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Drawer>
      {inspection && (
        <Dialog
          open={checked}
          className='dialog'
          sx={{ zIndex: 1300, position: 'absolute' }}
        >
          <DialogContent>
            <Box
              className='closeIcon d-flex icon-position'
              onClick={() => {
                setChecked(false);
                setInspection(false);
              }}
            >
              <CustomIconButton category='CloseValue' />
            </Box>
            <InspectionView
              setChecked={setChecked}
              setInspection={setInspection}
              setInspectionName={setInspectionName}
              setInspectionId={setInspectionId}
            />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default AddDispatch;
